<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-dialog
  [(visible)]="open"
  [closeOnEscape]="true"
  modal="modal"
  showEffect="fade"
  [keepInViewport]="false"
  [draggable]="false"
  header="Crear Unidad de Medida"
  [style]="{ width: '600px' }"
  (onHide)="onClose()"
>
  <div class="grid">
    <div class="col-12">
      <form [formGroup]="fg">
        <div class="p-fluid p-formgrid grid">
          <div class="field col-12 md:col-6">
            <label>Nombre</label>
            <input pInputText formControlName="description" type="text" />
            <div
              *ngIf="
                fg.get('description').invalid &&
                (fg.get('description').dirty || fg.get('description').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('description').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('description').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 3.</small
                >
              </div>
              <div *ngIf="fg.get('description').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máxima de 50.</small
                >
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <label>Símbolo</label>
            <input pInputText formControlName="symbol" type="text" />
            <div
              *ngIf="
                fg.get('symbol').invalid &&
                (fg.get('symbol').dirty || fg.get('symbol').touched)
              "
              class="p-invalid"
            >
              <div *ngIf="fg.get('symbol').errors?.required">
                <small class="p-error">No puede quedar vacío.</small>
              </div>
              <div *ngIf="fg.get('symbol').errors?.minlength">
                <small class="p-error"
                  >Debe tener una longitud mínima de 3.</small
                >
              </div>
              <div *ngIf="fg.get('symbol').errors?.maxlength">
                <small class="p-error"
                  >Debe tener una longitud máximo de 10.</small
                >
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-8"></div>
          <div class="field col-12 md:col-2">
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              label="No"
            ></button>
          </div>
          <div class="field col-12 md:col-2">
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="fg.invalid"
              label="Si"
            ></button>
          </div>
        </div>
      </form>
    </div></div
></p-dialog>
